import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Industries from "@/pages/Industries";
import IndustryDetail from "@/pages/IndustryDetail";
import ResourcesHub from "@/pages/ResourcesHub";
import ArticlePage from "@/pages/ArticlePage";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import LandingAtlanta from "@/pages/LandingAtlanta";
import AdminLogin from "@/pages/AdminLogin";
import AdminLeads from "@/pages/AdminLeads";

// Re-run hash scroll a few times (ms) so the target lands correctly even after
// below-the-fold images and entrance animations finish expanding layout.
const HASH_SCROLL_RETRY_DELAYS_MS = [80, 350, 700];

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const timers = HASH_SCROLL_RETRY_DELAYS_MS.map((ms) =>
        setTimeout(() => {
          const el = document.getElementById(id);
          if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, ms)
      );
      const el0 = document.getElementById(id);
      if (!el0) window.scrollTo(0, 0);
      return () => timers.forEach(clearTimeout);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

// Standalone paid-search landing pages and the internal admin dashboard render
// without the global nav/footer.
const BARE_ROUTES = ["/managed-it-services-atlanta", "/admin/login", "/admin/leads"];

const Shell = () => {
  const { pathname } = useLocation();
  const bare = BARE_ROUTES.includes(pathname);
  return (
    <>
      <ScrollToTop />
      {!bare && <Navbar />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/industries/:slug" element={<IndustryDetail />} />
          <Route path="/resources" element={<ResourcesHub />} />
          <Route path="/resources/:slug" element={<ArticlePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/managed-it-services-atlanta" element={<LandingAtlanta />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
        </Routes>
      </main>
      {!bare && <Footer />}
      <Toaster position="top-right" richColors />
    </>
  );
};

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-white">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </div>
  );
}

export default App;
